<template>
    <div class="modal fade" tabindex="-1" aria-labelledby="accountModalLabel" :id="id">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fa-solid fa-user"></i>
                        <span v-if="user.id">ユーザー編集</span>
                        <span v-else>ユーザー新規追加</span>
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <!-- 左カラム: 基本情報 -->
                        <div class="col-md-6">
                            <div class="mb-4" v-if="user.account">
                                <div class="d-flex align-items-center mb-1">
                                    <span class="fs-5 fw-bold">{{ user.name }}</span>
                                    <span class="badge bg-danger ms-2" v-if="user.is_root">管理者</span>
                                </div>
                                <div class="small">
                                    {{ user.section }}
                                </div>
                            </div>
                            <div class="mb-3" v-else>
                                <label class="form-label fw-semibold">
                                    <i class="fa-solid fa-file-signature"></i>
                                    氏名
                                </label>
                                <input type="text" class="form-control form-control-lg" v-model="user.name">
                            </div>

                            <div class="mb-3">
                                <label class="form-label fw-semibold">
                                    <i class="fa-regular fa-envelope"></i>
                                    メールアドレス
                                </label>
                                <input type="email" class="form-control" v-model="user.email" :readonly="user.account">
                                <div class="small text-danger" v-if="user.account">
                                    AD同期ユーザのメールアドレスは変更できません。
                                </div>
                            </div>

                            <div class="mb-3">
                                <label class="form-label fw-semibold">
                                    <i class="fa-brands fa-google"></i>
                                    Gmail
                                </label>
                                <input type="email" class="form-control" v-model="user.gmail" 
                                    placeholder="外部ログインする人はGoogleアカウントを設定">
                            </div>

                            <div class="mb-3">
                                <label class="form-label fw-semibold">
                                    <i class="fa-solid fa-key"></i>
                                    パスワード
                                </label>
                                <input type="password" class="form-control" v-model="user.password"
                                    placeholder="変更しない場合は空欄にしてください"
                                    autocomplete="new-password">
                            </div>

                            <div class="mt-4 pt-3 d-grid">
                                <label class="btn btn-outline-danger" :class="{active: user.is_root}">
                                    <input type="checkbox" v-model="user.is_root" class="d-none">
                                    <i class="fa-solid fa-square-check me-2" v-if="user.is_root"></i>
                                    <i class="fa-regular fa-square me-2" v-else></i>
                                    管理者権限
                                </label>
                            </div>

                            <div class="mt-4 pt-3 d-grid">
                                <label class="btn btn-outline-warning" :class="{active: user.locked_at}"
                                    @click="toggleLock()">
                                    <i class="fa-solid fa-square-check me-2" v-if="user.locked_at"></i>
                                    <i class="fa-regular fa-square me-2" v-else></i>
                                    ロック（ログイン禁止）
                                </label>
                            </div>
                        </div>

                        <!-- 右カラム: メニュー権限 -->
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label fw-semibold mb-3">
                                    <i class="fa-solid fa-wand-magic-sparkles"></i>
                                    メニュー権限
                                </label>
                                <h6 class="text-muted mb-3">メニュー権限</h6>
                                <div v-for="m in menus" :key="m.id" class="mb-2">
                                    <!-- カテゴリヘッダー -->
                                    <div v-if="!m.path" class="fw-semibold text-secondary small mt-3 mb-2">
                                        {{ m.name }}
                                    </div>
                                    <!-- 権限ボタン -->
                                    <div v-else>
                                        <label class="btn btn-outline-secondary w-100 text-start" :class="{
                                            active: hasAuth(m),
                                            disabled: user.is_root
                                        }" @click="toggle(m)">
                                            <i class="fa-solid fa-square-check me-2" v-if="hasAuth(m)"></i>
                                            <i class="fa-regular fa-square me-2" v-else></i>
                                            {{ m.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" @click="close()">閉じる</button>
                    <button class="btn btn-primary" @click="save">保存</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        id: {
            default: 'user-editor'
        },
        user_id: {
            default: null,
        }
    },
    data() {
        return {
            user: {},
            menus: [],
        }
    },
    methods: {
        init() {
            axios.get("/api/admin/menus/").then(res => {
                this.menus = res.data;
            }).catch(err => {Alert.err(err)});
        },
        close() {
            this.$emit('close', this.id);
        },
        reload() {
            if (!this.user_id) {
                this.user = {
                    menus: [],
                };
                return;
            }
            axios.get(`/api/admin/user?id=${this.user_id}`).then(res => {
                if (res.data.is_root) {
                    res.data.is_root = true;
                }
                this.user = res.data;
            }).catch(err => {Alert.err(err)});
        },
        save() {
            axios.post(`/api/admin/user`, this.user).then(() => {
                Alert.msg("保存しました");
                this.close();
                this.$emit("saved");
            }).catch(err => {Alert.err(err)});
        },
        hasAuth(m) {
            if (this.user.menus) {
                return this.user.menus.find((menu) => menu.id == m.id);
            } else {
                return false;
            }
        },
        toggle(m) {
            if (this.hasAuth(m)) {
                this.user.menus = this.user.menus.filter((menu) => menu.id != m.id);
            } else {
                this.user.menus.push(m);
            }
        },
        toggleLock() {
            if (this.user.locked_at) {
                this.user.locked_at = null;
            } else {
                this.user.locked_at = dayjs().format('YYYY-MM-DD HH:mm:ss');
            }
        },
    },
    mounted() {
        this.init();
        $(`#${this.id}`).on("show.bs.modal", (e) => {
            this.reload();
        });
    }
}
</script>